import {AfterViewInit, Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import * as L from 'leaflet';
import {CargoEnum, OrderData, StepEnum} from './app.interface';
import {HttpClient} from '@angular/common/http';
import {MapsService} from './maps.service';
import {EMPTY, fromEvent} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {environment} from '../environments/environment';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
L.Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {

  public orderData: any;

  public mask = ['+', /[7]/, '(', /[1-9]/, /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  public destinationMarker: any;
  public sourceMarker: any;
  public polyline: any;

  public catPereprobeg = {
    [CargoEnum.SMALL]: 70,
    [CargoEnum.MEDIUM]: 80,
    [CargoEnum.LARGE]: 85
  };

  public catPrice = {
    [CargoEnum.SMALL]: 2000,
    [CargoEnum.MEDIUM]: 2300,
    [CargoEnum.LARGE]: 2500
  };

  public sourceAutocomplete: any[] = [];
  public destinationAutocomplete: any[] = [];
  public cargoEnum = CargoEnum;
  public stepEnum = StepEnum;
  public isFirstPointLoading = false;
  public isSecondPointLoading = false;
  public isFirstPointShow = false;
  public isSecondPointShow = false;
  public currentStep: StepEnum = this.stepEnum.ORDER;
  public map;
  public data: OrderData = {
    coords: [{
      lat: undefined,
      lon: undefined,
      address: undefined
    },
      {
        lat: undefined,
        lon: undefined,
        address: undefined
      }],
    dateStart: undefined,
    categoryId: this.cargoEnum.MEDIUM,
    driverHelp: false,
    isHotOrder: false,
    name: '',
    phone: '',
    insideDistance: 0,
    outsideDistance: 0,
    totalDistance: 0,
    totalPrice: 0
  };
  title = 'fiz-order';

  public routerLoading = false;

  @ViewChild('source')
  private source: ElementRef;
  private sourceStream$;

  @ViewChild('destination')
  private destination: ElementRef;
  private destinationStream$;

  constructor(
    private http: HttpClient,
    private readonly mapsService: MapsService,
    private localeService: BsLocaleService
  ) {
    this.localeService.use('ru');
  }

  public mapWidth: number = 1048;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.mapWidth = window.innerWidth - 392;
  }

  ngAfterViewInit(): void {
    this.initMap();
    // this.currentStep = StepEnum.DONE;
    this.sourceStream$ = fromEvent<any>(this.source.nativeElement, 'input')
      .pipe(
        tap(event => {
          this.isFirstPointLoading = true;
          this.isFirstPointShow = false;
          return event;
        }),
        map(event => event.target.value),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(value => this.http.post('https://maps.tk-akro.ru/api/autocomplete/get', {
          address: value
        }, {
          headers: {
            token: 'asdfasdf2534-gfgdsg4v4256-dsgdf4g43tgdf-dfgs'
          }
        }).pipe(
          catchError(err => {
            this.isFirstPointShow = false;
            this.isFirstPointLoading = false;
            this.sourceAutocomplete = [];
            return EMPTY;
          })
        )),
        tap((value: any) => {
          this.isFirstPointShow = true;
          this.isFirstPointLoading = false;
          this.sourceAutocomplete = value.data.array;
          return value;
        }),
      )
      .subscribe();

    this.destinationStream$ = fromEvent<any>(this.destination.nativeElement, 'input')
      .pipe(
        tap(event => {
          this.isSecondPointLoading = true;
          this.isSecondPointShow = false;
          return event;
        }),
        map(event => event.target.value),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(value => this.http.post('https://maps.tk-akro.ru/api/autocomplete/get', {
          address: value
        }, {
          headers: {
            token: 'asdfasdf2534-gfgdsg4v4256-dsgdf4g43tgdf-dfgs'
          }
        }).pipe(
          catchError(err => {
            this.isSecondPointShow = false;
            this.isSecondPointLoading = false;
            this.destinationAutocomplete = [];
            return EMPTY;
          })
        )),
        tap((value: any) => {
          this.isSecondPointShow = true;
          this.isSecondPointLoading = false;
          this.destinationAutocomplete = value.data.array;
          return value;
        }),
      )
      .subscribe();
  }

  public async order(): Promise<void> {
    this.currentStep = StepEnum.CONFIRM;
  }

  public async confirm(): Promise<void> {
    await this.sendOrderToServer();
  }

  public async onFocusOutEvent(event: any, type: 'SOURCE' | 'DESTINATION'): Promise<void> {
    if (event?.relatedTarget?.id === 'sourceAddress') {
      return;
    }
    if (event?.relatedTarget?.id === 'destinationAddress') {
      return;
    }
    if (type === 'SOURCE') {
      this.isFirstPointShow = false;
      this.isFirstPointLoading = false;
    }
    if (type === 'DESTINATION') {
      this.isSecondPointShow = false;
      this.isSecondPointLoading = false;
    }
  }

  public async onFocusEvent(event: any, type: 'SOURCE' | 'DESTINATION'): Promise<void> {
    if (type === 'SOURCE' && this.sourceAutocomplete.length > 0) {
      this.isFirstPointShow = true;
    }
    if (type === 'DESTINATION' && this.destinationAutocomplete.length > 0) {
      this.isSecondPointShow = true;
    }
  }

  public async setAddress(type: 'SOURCE' | 'DESTINATION', placeId: string, address: string): Promise<void> {
    if (type === 'SOURCE') {
      this.data.coords[0].address = address;
      this.isFirstPointShow = false;
      await this.http.post<any>('https://maps.tk-akro.ru/api/place-geocode/get', {
        placeId
      }, {
        headers: {
          token: 'asdfasdf2534-gfgdsg4v4256-dsgdf4g43tgdf-dfgs'
        }
      }).toPromise().then((data) => {
        this.data.coords[0].lat = data.data.lat;
        this.data.coords[0].lon = data.data.lon;
        if (this.sourceMarker) {
          this.sourceMarker.setLatLng([this.data.coords[0].lat, this.data.coords[0].lon]);
          return;
        }
        this.sourceMarker = L.marker([this.data.coords[0].lat, this.data.coords[0].lon]);
        this.sourceMarker.addTo(this.map);
      }).catch((err) => {
      });
      this.isSecondPointLoading = false;
      await this.getRoute();
    }
    if (type === 'DESTINATION') {
      this.data.coords[1].address = address;
      this.isSecondPointShow = false;
      this.isSecondPointLoading = true;
      await this.http.post<any>('https://maps.tk-akro.ru/api/place-geocode/get', {
        placeId
      }, {
        headers: {
          token: 'asdfasdf2534-gfgdsg4v4256-dsgdf4g43tgdf-dfgs'
        }
      }).toPromise().then((data) => {
        this.data.coords[1].lat = data.data.lat;
        this.data.coords[1].lon = data.data.lon;
        if (this.destinationMarker) {
          this.destinationMarker.setLatLng([this.data.coords[1].lat, this.data.coords[1].lon]);
          return;
        }
        this.destinationMarker = L.marker([this.data.coords[1].lat, this.data.coords[1].lon]);
        this.destinationMarker.addTo(this.map);
      }).catch((err) => {
      });
      this.isSecondPointLoading = false;
      await this.getRoute();
    }
  }

  public async getRoute(): Promise<void> {
    if (!this.data.coords[0].lat || !this.data.coords[1].lat) {
      return;
    }
    this.routerLoading = true;
    await this.http.post<any>('https://maps.tk-akro.ru/api/route/calc/moscow', {
      polygonDistance: 0,
      avoid: 'EMPTY',
      isCargo: false,
      points: [
        {
          lat: this.data.coords[0].lat,
          lon: this.data.coords[0].lon
        },
        {
          lat: this.data.coords[1].lat,
          lon: this.data.coords[1].lon
        }
      ]
    }, {
      headers: {
        token: 'asdfasdf2534-gfgdsg4v4256-dsgdf4g43tgdf-dfgs'
      }
    }).toPromise().then((data) => {
      this.data.outsideDistance = data.data.outside;
      this.data.totalDistance = data.data.distance;
      this.data.insideDistance = data.data.inside;
      if (this.polyline) {
        this.polyline.setLatLngs(data.data.coordinates);
        return;
      }
      this.polyline = L.polyline(data.data.coordinates);
      this.polyline.addTo(this.map);
    }).catch((err) => {
      console.log(err);
    });
    this.routerLoading = false;
  }

  public round(data: number): number {
    return Math.round(data);
  }

  public getPrice(): number {
    let price = this.catPrice[this.data.categoryId];
    if (this.data.driverHelp) {
      price = price + 1000;
    }
    if (this.data.outsideDistance > 0) {
      const outsideDistance = this.catPereprobeg[this.data.categoryId] * this.round(this.data.outsideDistance / 1000);
      price = price + outsideDistance;
    }
    if (this.round(this.data.insideDistance / 1000) > 30) {
      const insideDistance = this.round((this.data.insideDistance / 1000) - 30) * this.catPereprobeg[this.data.categoryId];
      price = price + insideDistance;
    }
    this.data.totalPrice = price;
    return price;
  }

  public isOrderHidden(): boolean {
    if (!this.data.coords[0].lat || !this.data.coords[1].lat) {
      return true;
    }
    return false;
  }

  public setHotOrderDate(): void {
    if (this.data.isHotOrder) {
        this.data.dateStart = new Date();
    } else {
      this.data.dateStart = undefined;
    }
  }

  private initMap(): void {
    this.map = L.map('map', {
      center: [55.753330, 37.616545],
      zoom: 8
    });

    const tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: '&copy; <a href="https://tk-akro.ru/">AKRO Routing</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'dmitry-drozdov/ckz16smev005215p1jncfhyze',
      tileSize: 512,
      zoomOffset: -1,
      accessToken: 'pk.eyJ1IjoiZG1pdHJ5LWRyb3pkb3YiLCJhIjoiY2szYThsamY2MDYwYzNtbGR6OThqdXRpZiJ9.Zh9qQLmBt9EQ-wA-2vCLOQ'
    });

    tiles.addTo(this.map);
  }

  public getConfirm(): boolean {
    let isConfirm = true;
    if (!this.data.dateStart) {
      isConfirm = false;
    }
    if (this.data.name.length < 3) {
      isConfirm = false;
    }
      try {
        let value = this.data.phone.toString();
        value = value.replaceAll('+', '');
        value = value.replaceAll('_', '');
        value = value.replaceAll(' ', '');
        value = value.replaceAll('(', '');
        value = value.replaceAll(')', '');
        value = value.replaceAll('-', '');
        if (value.length !== 11) {
          isConfirm = false;
        }
      } catch (er) {
        isConfirm = false;
      }
    return isConfirm;
  }

  public async sendOrderToServer(): Promise<void> {
    this.data.totalDistance = this.round(this.data.totalDistance / 1000);
    this.data.outsideDistance = this.round(this.data.outsideDistance / 1000);
    this.data.insideDistance = this.round((this.data.insideDistance / 1000) - 30);
    if (this.data.insideDistance < 0) {
      this.data.insideDistance = 0;
    }
    const date = this.data.dateStart as Date;
    this.data.dateStart = date.toISOString();
    this.http.post<any>(environment.api + '/api/client/order/fiz-moscow/create', {...this.data}).toPromise()
      .then((data) => {
        this.orderData = data.data;
        this.currentStep = StepEnum.DONE;
      })
      .catch((err) => {
      });
  }
}
